<script setup lang="ts">
import { useConfirmStore } from '@/stores/confirmStore';
import { useI18n } from 'vue-i18n';
import {
    BDialogCloseBtn, BCard, BBtn,
} from '@/design-system';

const confirmStore = useConfirmStore();
const { t } = useI18n();

const confirm = (): void => {
    if (confirmStore.resolve) {
        confirmStore.resolve(true);
        confirmStore.open = false;
    }
};
const cancel = (): void => {
    if (confirmStore.resolve) {
        confirmStore.resolve(false);
        confirmStore.open = false;
    }
};
</script>

<template>
    <VDialog
        v-model="confirmStore.open"
        max-width="400"
    >
        <BDialogCloseBtn @click="cancel" />

        <BCard
            title-class="pa-4"
            actions-class="pa-4"
        >
            <template #title>
                <span class="title">{{ confirmStore.title }}</span>
            </template>

            <template #default>
                <p style="white-space: pre-line">
                    {{ confirmStore.text }}
                </p>
            </template>

            <template #actions>
                <VSpacer />

                <BBtn
                    color="secondary"
                    variant="tonal"
                    @click="cancel"
                    rounded
                    class="btn-dialog-cta-action"
                >
                    {{ t(confirmStore.cancelBtnText) }}
                </BBtn>

                <BBtn
                    color="error"
                    variant="flat"
                    rounded
                    class="btn-dialog-cta-action"
                    @click="confirm"
                >
                    {{ t(confirmStore.confirmBtnText) }}
                </BBtn>
            </template>
        </BCard>
    </VDialog>
</template>
